import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

import _4a341622 from '../pages/blog/index.vue'
import _100f11d0 from '../pages/car-results.vue'
import _ad687e20 from '../pages/hotel-results.vue'
import _bdd273e2 from '../pages/loading.vue'
import _e01d986e from '../pages/results.vue'
import _308cf66b from '../pages/static.vue'
import _aa8e2a22 from '../pages/blog/page.vue'
import _b6c49f00 from '../pages/blog/post.vue'
import _6e7c2565 from '../pages/index.vue'

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blog",
    component: _4a341622,
    name: "blog"
  }, {
    path: "/car-results",
    component: _100f11d0,
    name: "car-results"
  }, {
    path: "/hotel-results",
    component: _ad687e20,
    name: "hotel-results"
  }, {
    path: "/loading",
    component: _bdd273e2,
    name: "loading"
  }, {
    path: "/results",
    component: _e01d986e,
    name: "results"
  }, {
    path: "/static",
    component: _308cf66b,
    name: "static"
  }, {
    path: "/blog/page",
    component: _aa8e2a22,
    name: "blog-page"
  }, {
    path: "/blog/post",
    component: _b6c49f00,
    name: "blog-post"
  }, {
    path: "/",
    component: _6e7c2565,
    name: "index"
  }, {
    path: "/privacy",
    component: _308cf66b,
    name: "privacy"
  }, {
    path: "/terms",
    component: _308cf66b,
    name: "terms"
  }, {
    path: "/about",
    component: _308cf66b,
    name: "about"
  }, {
    path: "/contact",
    component: _308cf66b,
    name: "contact"
  }, {
    path: "/flights",
    component: _4a341622,
    name: "articles_flights_index_page"
  }, {
    path: "/flights/:page(\\d+)?",
    component: _4a341622,
    name: "articles_flights_paged_page"
  }, {
    path: "/flights/:slug",
    component: _aa8e2a22,
    name: "articles_page_page"
  }, {
    path: "/blog/:hasPage(page)?/:page(\\d+)?",
    component: _4a341622,
    name: "articles_index_page"
  }, {
    path: "/blog/:category/:hasPage(page)?/:page(\\d+)?",
    component: _4a341622,
    name: "articles_category_page"
  }, {
    path: "/blog/:category/author/:author/:hasPage(page)?/:page(\\d+)?",
    component: _4a341622,
    name: "articles_author_page"
  }, {
    path: "/blog/:category/:slug?",
    component: _b6c49f00,
    name: "articles_post_page"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
